<router-outlet></router-outlet>
<app-footer ></app-footer>

<div *ngIf="loadingService.loading$ | async" class="loading-overlay">
    <img src="./../assets/loading.gif">
</div>